/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareRightIcon16Solid = forwardRef('ArrowFigureASquareRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 1A3.5 3.5 0 0 0 1 4.5v7A3.5 3.5 0 0 0 4.5 15h7a3.5 3.5 0 0 0 3.5-3.5v-7A3.5 3.5 0 0 0 11.5 1h-7Zm3.445 3.55a.75.75 0 0 0 .061 1.058L9.85 7.25H4.234a.75.75 0 1 0 0 1.5H9.85l-1.844 1.642a.75.75 0 0 0 .998 1.12l2.476-2.205a1.75 1.75 0 0 0 0-2.614L9.004 4.488a.75.75 0 0 0-1.059.061Z" })));
});
